import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

interface CommissionRulesState {
  list: any[];
  count: number;
  activeItem: any;
  loading: boolean;
  activeItemLoading: boolean;
}

const initialState: CommissionRulesState = {
  list: [],
  count: 0,
  activeItem: {},
  loading: false,
  activeItemLoading: false,
};

export const getCommissionRulesList = createAsyncThunk(
  "commissionRules/getCommissionRulesList",
  async (
    { isDefault, search, caseType }: any,
    { rejectWithValue }
  ) => {
    try {
      const response: any =
        await apiServices.systemManager.commissionRule.getList(
          isDefault,
          search || "",
          caseType || ""
        );
      const { isError, data, pagination } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch list");
      }

      return { list: data, count: pagination ? pagination.count : 0 };
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getCommissionRuleDetailById = createAsyncThunk(
  "commissionRules/getCommissionRuleDetailById",
  async (Id: string | number, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid ID");

    const state: any = getState();
    const itemList = state.commissionRules.list;

    const itemDetail = itemList.find(
      (item: any) => String(item.id) === String(Id)
    );
    if (itemDetail) {
      return itemDetail;
    } else {
      return rejectWithValue("Item detail not found in state");
    }
  }
);

export const commissionRulesSlice = createSlice({
  name: "commissionRules",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCommissionRulesList.pending, (state) => {
        state.loading = true;
        state.list = [];
        state.count = 0;
      })
      .addCase(getCommissionRulesList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.count = action.payload.count;
      })
      .addCase(getCommissionRulesList.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching list:", action.payload);
      })
      .addCase(getCommissionRuleDetailById.pending, (state) => {
        state.activeItemLoading = true;
        state.activeItem = {};
      })
      .addCase(getCommissionRuleDetailById.fulfilled, (state, action) => {
        state.activeItemLoading = false;
        state.activeItem = action.payload;
      })
      .addCase(getCommissionRuleDetailById.rejected, (state, action) => {
        state.activeItemLoading = false;
        console.error("Error fetching details:", action.payload);
      });
  },
});

export default commissionRulesSlice.reducer;
